import { render, staticRenderFns } from "./EbookHeader.vue?vue&type=template&id=34f36ea5&scoped=true&"
import script from "./EbookHeader.vue?vue&type=script&lang=js&"
export * from "./EbookHeader.vue?vue&type=script&lang=js&"
import style0 from "./EbookHeader.vue?vue&type=style&index=0&id=34f36ea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f36ea5",
  null
  
)

export default component.exports